

<section class="offline section-pd" [class.is-off]="off">
    <div class="band">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="band-inner">
    
                        <div class="copy">
                            <!-- <span class="badge">40% off · Limited time</span> -->
                            <h2 class="checks-title offline-title">Check grammar with your Wi-Fi <span
                                    class="checks-title-accent">switched off.</span></h2>
                            <p class="copy-text">An AI grammar checker that runs on your Windows computer, included in the
                                Confidential Data Plan. Your writing stays on your device.</p>
                            <div class="copy-actions">
                                <a 
                                    [href]="buildPlanCheckoutUrl('confidential data', {
                                    coupon: 'BTS40',
                                    utm_source: 'website',
                                    utm_medium: 'get_now',
                                    utm_campaign: 'gc_cdp',
                                    utm_id: 'cdp_grammar_checker'
                                    })"
                                    target="_blank"
                                    class="cta offline-cta"
                                >
                                    Get offline access
                                    <span class="cta-arrow">
                                        <svg width="22px" height="22px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M13.2328 16.4569C12.9328 16.7426 12.9212 17.2173 13.2069 17.5172C13.4926 17.8172 13.9673 17.8288 14.2672 17.5431L13.2328 16.4569ZM19.5172 12.5431C19.8172 12.2574 19.8288 11.7827 19.5431 11.4828C19.2574 11.1828 18.7827 11.1712 18.4828 11.4569L19.5172 12.5431ZM18.4828 12.5431C18.7827 12.8288 19.2574 12.8172 19.5431 12.5172C19.8288 12.2173 19.8172 11.7426 19.5172 11.4569L18.4828 12.5431ZM14.2672 6.4569C13.9673 6.17123 13.4926 6.18281 13.2069 6.48276C12.9212 6.78271 12.9328 7.25744 13.2328 7.5431L14.2672 6.4569ZM19 12.75C19.4142 12.75 19.75 12.4142 19.75 12C19.75 11.5858 19.4142 11.25 19 11.25V12.75ZM5 11.25C4.58579 11.25 4.25 11.5858 4.25 12C4.25 12.4142 4.58579 12.75 5 12.75V11.25ZM14.2672 17.5431L19.5172 12.5431L18.4828 11.4569L13.2328 16.4569L14.2672 17.5431ZM19.5172 11.4569L14.2672 6.4569L13.2328 7.5431L18.4828 12.5431L19.5172 11.4569ZM19 11.25L5 11.25V12.75L19 12.75V11.25Z" fill="#0b4d2c"></path> </g></svg>
                                    </span>
                                </a>
                                <a [routerLink]="['/pricing']" class="explore">Explore all plans</a>
                            </div>
                        </div>
    
                        <div class="demo">
                            <div class="window">
                                <div class="window-bar">
                                    <span class="lights">
                                        <span class="light"></span>
                                        <span class="light"></span>
                                        <span class="light"></span>
                                    </span>
                                    <button type="button" role="switch" class="wifi" aria-label="Wi-Fi" [attr.aria-checked]="!off"
                                        (click)="toggle()">
                                        <svg *ngIf="!off" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#3F3F46"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                                            <path d="M2 8.5a15 15 0 0 1 20 0M5.5 12a10 10 0 0 1 13 0M9 15.5a5 5 0 0 1 6 0"></path>
                                            <circle cx="12" cy="19" r="1"></circle>
                                        </svg>
                                        <svg *ngIf="off" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#B91C1C"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                                            <path d="M2 8.5a15 15 0 0 1 20 0M5.5 12a10 10 0 0 1 13 0M9 15.5a5 5 0 0 1 6 0"></path>
                                            <circle cx="12" cy="19" r="1"></circle>
                                            <path d="M3 3l18 18"></path>
                                        </svg>
                                        Wi-Fi<span class="track" [class.is-off]="off"><span class="knob"
                                                [class.is-off]="off"></span></span>
                                    </button>
                                </div>
                                <div class="window-body">
                                    <p class="sample">Patient outcomes <span *ngIf="fixA" class="pop fixed-chip">were</span><span
                                            *ngIf="!fixA" class="error">was</span> recorded at each visit, and the data <span
                                            *ngIf="fixB" class="pop fixed-chip">are stored</span><span *ngIf="!fixB"
                                            class="error">is store</span> on a secure local drive.</p>
                                    <div class="status" [class.is-off]="off">
                                        <span class="status-dot" [class.is-off]="off" [class.pulse]="pulsing"></span>
                                        <span class="status-text">{{ status }}</span>
                                        <span class="status-right">{{ statusRight }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
    
                    </div>
                </div>
            </div>
        </div>
    </div>    
</section>